// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3m7SH","savePackageButton":"ClientWallet_savePackageButton__1fVQo"};